export default Object.freeze({
  Basic: 1, // 'basic'
  FilterByProcess: 2, // 'filter-by-process'
  FilterByTaskImportances: 3, // 'filter-by-task-importance'
  LinkCustomList: 4, // 'link-custom-list,'
  AdvancedFilter: 5, // 'advanced-filter'
  FilterByTaskType: 6, // 'filter-by-task-type'
});
